import yup from '@/libs/yup';

export default yup.object({
    idn: yup.string().required('Name is a required field').idn(),
    description: yup.string().trim(),
    connector_idn: yup.string().required('Connector is a required field'),
    event_idns: yup
        .array()
        .of(yup.string().idn())
        .required('Events are required'),
    allowed_ips: yup
        .array()
        .of(yup.string())
        .required('Allowed IPs are required')
});
